/**
 * @generated SignedSource<<0949b22fe54f14f271ad75bdca46db6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type oneSectionTopWidgetQueue$data = {
  readonly variantOneItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "contentItemRenderContent" | "entityLink">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "oneSectionTopWidgetQueue";
};
export type oneSectionTopWidgetQueue$key = {
  readonly " $data"?: oneSectionTopWidgetQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetQueue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeEntityIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "oneSectionTopWidgetQueue",
  "selections": [
    {
      "alias": "variantOneItems",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityIds",
              "variableName": "excludeEntityIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "exclude"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 7
        }
      ],
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "entityLink"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentItemRenderContent"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentCoverImageContent"
                    }
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};

(node as any).hash = "83d6b993f310400c56084876bb2ca03b";

export default node;
